enum AssetType {
  IMAGE = "image",
  VIDEO = "video",
  GIF = "gif",
}

export { AssetType };